module.exports = __webpack_public_path__ + "static/media/la-corporate-hero.39bfa12f.jpg";